const styles = (theme) => ({
	container: {
		p: { xs: 2, md: 3 },
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	header: {
		display: "flex",
		flexDirection: "column",
	},
	titulo: {
		fontSize: "1.5rem",
		fontWeight: 700,
		color: "text.primary",
	},
	subtitulo: {
		color: "text.secondary",
		fontSize: "0.9rem",
	},
	abas: {
		borderBottom: 1,
		borderColor: "divider",
		mb: 1,
	},
	loading: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		minHeight: 300,
	},
});

export default styles;
